<template>
  <div :class="classObj" class="app-wrapper">
    <div class="drawer-bg" @click="handleClickOutside" />
    <!-- <sidebar class="sidebar-container" /> -->
    <!-- <div class="main-container">
      <navbar />
    </div> -->
    <div class="module">
      <sidebar />

      <div class="district" :class="[isCollapse ? 'addclass' : '']">
        <navbar class="nav-bar" :class="[isCollapse ? 'addNavbar' : '']" />
        <app-main class="app-main" />
      </div>
    </div>
  </div>
</template>

<script>
// import Sidebar from './components/Sidebar'
import AppMain from "./components/AppMain";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar/index";
// import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: "Layout",
  data() {
    return {
      isCollapse: this.$store.state.app.isCollapse,
    };
  },
  components: {
    Navbar,
    Sidebar,
    AppMain,
  },
  //   mixins: [ResizeMixin],
  computed: {
    // sidebar() {
    //   return this.$store.state.app.sidebar
    // },
    // device() {
    //   return this.$store.state.app.device
    // },
    // fixedHeader() {
    //   return this.$store.state.settings.fixedHeader
    // },
    classObj() {
      return {
        // hideSidebar: !this.sidebar.opened,
        // openSidebar: this.sidebar.opened,
        // withoutAnimation: this.sidebar.withoutAnimation,
        // mobile: this.device === 'mobile'
      };
    },
  },
  created() {
    this.$store.watch(
      (state, getters) => {
        return state.app.isCollapse;
      },
      () => {
        this.isCollapse = this.$store.state.app.isCollapse;
      }
    );
  },
  methods: {
    handleClickOutside() {
      //   this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
  },
};
</script>

<style lang="scss" scoped>
//   @import "~@/styles/mixin.scss";
//   @import "~@/styles/variables.scss";

.app-wrapper {
  // @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  // width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
.module {
  display: flex;
  .district {
    flex: 1;
    z-index: 1999;
    display: flex;
    flex-direction: column;
    padding-left: 256px;
    width: calc(100% - 256px);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border 0s,
      background 0s, color 0s, font-size 0s;
    box-sizing: border-box;
    &.addclass {
      padding-left: 64px;
      width: calc(100% - 64px);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border 0s,
        background 0s, color 0s, font-size 0s;
    }
    .app-main {
      // margin-left: 340px;
    }
    .nav-bar {
      position: fixed;
      top: 0;
      left: 256px;
      width: calc(100% - 256px);
      transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border 0s,
        background 0s, color 0s, font-size 0s;
      &.addNavbar {
        // padding-left: 64px;
        left: 64px;
        width: calc(100% - 64px);
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), border 0s,
          background 0s, color 0s, font-size 0s;
      }
    }
  }
}
</style>
